<template>
  <div>
    <portal target-el="#filter">
      <primary-filter
        :noSearchFilter="true" />
    </portal>
  </div>
</template>
<script>
import PrimaryFilter from '@/components/common/PrimaryFilter';

export default {
  components: { PrimaryFilter },
  created() {
    const token = localStorage.getItem('tsm-user-token');
    let baseUrl = this.$route.query.serviceUrl;
    const hasPermission = this.$hasPermission('view_order_hub');
    if (hasPermission) {
      if (this.$route.params.isFromLogin) {
        baseUrl = window.location.host;
        const isDevelopment = baseUrl.startsWith('localhost') || baseUrl.startsWith('127.0.0.1:8080');
        if (isDevelopment) {
          baseUrl = 'localhost:8081/';
          const index = baseUrl.indexOf('.');
          baseUrl = (index !== -1) ? `${baseUrl.substring(0, index)}-ohub${baseUrl.substring(index, baseUrl.length)}` : baseUrl;
          baseUrl = `http://${baseUrl}?token=${token}`;
          window.open(baseUrl, '_self');
          return;
        }
        const index = baseUrl.indexOf('.');
        baseUrl = (index !== -1) ? `${baseUrl.substring(0, index)}-ohub${baseUrl.substring(index, baseUrl.length)}` : baseUrl;
        baseUrl = `https://${baseUrl}?token=${token}`;
        window.open(baseUrl, '_self');
        return;
      }
      const url = `https://${baseUrl}?token=${token}`;
      window.open(url, '_self');
    } else {
      this.$errorMessage({ message: this.$getErr('ERR_CONFIG_MISSING') });
    }
  },
};
</script>
